import dayjs from 'dayjs';
import { ValueFormatterParams } from 'ag-grid-community';

import { DEFAULT_DATE_PATTERN } from '@/config/common.config';

export interface AgGridDateFormatterParams {
  dateFormatPattern?: string;
}

interface IAgGridDateFormatter extends ValueFormatterParams, AgGridDateFormatterParams { }

export default function AgGridDateFormatter({ value, dateFormatPattern }: IAgGridDateFormatter) {
  const pattern = dateFormatPattern ?? DEFAULT_DATE_PATTERN;

  if (dayjs(value ?? null).isValid()) {
    return dayjs(value).format(pattern);
  }

  return value;
}
